import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const ForgotPassword = () => {
  const navigate = useNavigate(); 
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    try {
      console.log(email)
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      console.log(response)
      const data = await response.json();
      if (response.ok) {
        setMessage('A reset password link has been sent to your email.');
        //make a button appear to open gmail app or website

        setError('');
      } else {
        setMessage('');
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      setMessage('');
      setError('Internal Server Error. Please try again later.');
    }
  };

  return (
    <>
      <div
  className="head"
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Aligns Back and Next Page buttons to opposite sides
    padding: '10px 20px',
  }}
>
  {/* Back Button */}
  <button
    className="back-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    
    onClick={() => navigate(-1)}  // Go back to the previous page
  >
    
    &#x227A; Back
  </button>

  {/* Next Page Button */}
  {/* <button
    className="next-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    onClick={() => navigate('/featuresecond')}
  >
    Next Page &#x227B;
  </button> */}
</div>
    
    <div className='login-container'>
      <div className='logo-margin-below'>
        <h1 className="logo-login middle-align" onClick={() =>navigate('/')}>
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1>
      </div>
      {/* <h1 className="logo-login" onClick={() =>navigate('/')}>CommentInsight</h1> */}
      <h3 className='WELCOME-BACK'>Forget/Reset Password</h3>
      <p>Enter your email to receive a password reset link.</p>

      <form  onSubmit={handleSubmit} >
        <div className='password-container' style={{ marginBottom: '15px' }}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            
          />
        <button
          type="submit"
          className='signup-btn'
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="34px" fill="#FFFFFF"><path d="M0 0h24v24H0z" fill="none"/><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
          Submit
        </button>
        </div>

      </form>

      {message && <p style={{ color: 'green', marginTop: '15px' }}>{message}</p>}
      {/* //help open gmail app or website */}
      {message && <a href="https://mail.google.com/mail/u/0/#inbox" style={{ color: 'green', marginTop: '15px' }}>Open Gmail</a>}
      
      {error && <p style={{ color: 'red', marginTop: '15px' }}>{error}</p>}
      {/* Add a link to the login page */}
        <p onClick={()=>{navigate('/login')}}  style={{ marginTop: '15px' }}>
            Remember your password? 
            <span className="blue-color-underline"> Log In</span>
            </p>
    </div>
    </>
  );
};

export default ForgotPassword;
